module.exports = __webpack_public_path__ + "img/ether-outline.6738b807.svg";